import { connect } from 'react-redux'
import MaintenanceAppendModifyComponent from '../components/MaintenanceAppendModifyComponent.jsx';
import {
    clean,
	forwardToFindDetails,
	forwardToDeleteAppendDetail,
	forwardToFindCategories,
	forwardToShowMaintenanceModifyComponentModal,
	forwardToHideMaintenanceModifyComponentModal,
	forwardToAssignAppendCheckSet,
	forwardToAssignAppendCheckItem,
	forwardToAssignAppendCheckNote,
	forwardToAppendMissingDamageCheckDetail,
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceFixingReducer', 'request']),
	response: state.getIn(['maintenanceFixingReducer', 'response']),
	options: state.getIn(['maintenanceFixingReducer', 'options']),

	categories: state.getIn(['checkCardReducer', 'view', 'categories']),
})

const mapDispatchToProps = (dispatch) => ({

	findDetails: (card) => {
		dispatch(forwardToFindDetails(card));
		clean(dispatch);
	},

	deleteDetail: (detail, card) => {
		dispatch(forwardToDeleteAppendDetail(detail, card));
		clean(dispatch);
	},

	findCategories: () => {
		dispatch(forwardToFindCategories());
	},

	showAppendModal: (card, category) => {
		dispatch(forwardToShowMaintenanceModifyComponentModal(card, category));
	},
	hideAppendModal: () => {
		dispatch(forwardToHideMaintenanceModifyComponentModal());
	},

	assignAppendSet: (checkSet) => {
		dispatch(forwardToAssignAppendCheckSet(checkSet));
	},

	assignAppendItem: (checkItem) => {
		dispatch(forwardToAssignAppendCheckItem(checkItem));
	},

	assignAppendNote: (note) => {
		dispatch(forwardToAssignAppendCheckNote(note));
	},

	appendCheckDetail: (editing) => {
		dispatch(forwardToAppendMissingDamageCheckDetail(editing));
	}
})

const MaintenanceAppendModifyContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceAppendModifyComponent)

export default MaintenanceAppendModifyContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAppendModifyContainer.jsx